const ITEMS = [
  "Manufactured Housing Communities",
  "30/60/90-Day Onboarding Sprint",
  "Fair Housing Compliance Audits",
  "RV Resort Seasonal Operations",
  "Self-Storage Facility Operations",
  "HOA Covenant & Board Governance",
  "Move-In / Move-Out Accuracy",
  "Due-Diligence Acquisition Walks",
  "Community Operations Certification",
];

export const Marquee = () => (
  <div className="relative border-y border-slate-200 bg-[#E2EDF8] py-5 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-editorial italic text-lg sm:text-xl text-muted-foreground whitespace-nowrap px-6">
                {item}
              </span>
              <span className="text-sky-600 text-xs font-mono">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
